export class ConfigDB {
  static data = {
    settings: {
      layout_type: "ltr",
      sidebar: {
        type: "compact-wrapper",
      },
      sidebar_setting: "modern-sidebar",
    },
    color: {
      primary_color: "#2653a5",
      secondary_color: "#3c4252",
      mix_background_layout: "light-only",
    },
    router_animation: "fadeIn",
  };
}
export default ConfigDB;
